const MAIL_TO = 'mailto:info@exmaple.com';

export default MAIL_TO;
